export default "__VITE_ASSET__abd3280e__"